import Vue from 'vue'
import ReportCustom from '@ufe/reporter'

export const getVmSingleton = function (cmp) {
  let $vm = null
  return function () {
    if ($vm) return $vm
    else {
      const Constructor = Vue.extend(cmp)
      $vm = new Constructor({
        el: document.createElement('div')
      })
      document.body.appendChild($vm.$el)
      return $vm
    }
  }
}

export const WebReportSDK = function () {
  // if (process.env.NODE_ENV === 'development') return
  new ReportCustom({
    domain: 'https://web-monitor.funplus.com',
    appId: 'kMtZaHs1657509068761',
    autoErr: true,
    vueError: Vue,
    useBeaconFirst: true,
    extra: {
      appVersion: '1.0.1'
    }
  })
}

// axios 接口异常上报
export const httpReport = function (data) {
  const params = {
    type: 'axios',
    httpStatus: data.status,
    url: data.request.responseURL,
    request: data.config.data || data.config.params,
    response: data.data
  }
  console.error(JSON.stringify(params))
}

// ws 异常上报 (微端登录/切换账号)
export const wsReport = function (data) {
  const params = {
    type: 'ws',
    code: data.code,
    action: data.action,
    request: data.request
  }
  console.error(JSON.stringify(params))
}
